import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0, 0, 0, 0.5)"}
}
const _hoisted_2 = { class: "modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content border-0 shadow-lg" }
const _hoisted_4 = { class: "modal-header border-bottom py-3 px-3 bg-body" }
const _hoisted_5 = { class: "d-flex align-items-center w-100" }
const _hoisted_6 = { class: "modal-title fw-bold text-dark mb-0 me-3" }
const _hoisted_7 = { class: "modal-body bg-white p-3" }
const _hoisted_8 = {
  key: 2,
  class: "alert alert-danger border-0 bg-danger-subtle text-danger mt-4 rounded-3"
}
const _hoisted_9 = { class: "mb-0 ps-3 small" }
const _hoisted_10 = {
  key: 3,
  class: "alert alert-danger border-0 bg-danger-subtle text-danger mt-4 rounded-3"
}
const _hoisted_11 = { class: "mb-0 ps-4 small mt-1" }
const _hoisted_12 = { class: "modal-footer border-top pt-3 pb-3 px-3 bg-body" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "fas fa-spinner fa-spin me-2"
}
const _hoisted_16 = {
  key: 1,
  class: "fas fa-save me-2"
}

import { ref, reactive } from "vue";
import type {
  TelegramChannel,
  ChannelType,
  KickAfterUnit,
} from "@/stores/telegramChannels";
import { DEFAULT_MONITORING_CONFIG } from "@/stores/telegramChannels";
import ServiceChannelForm from "./form/ServiceChannelForm.vue";
import NetworkingChannelForm from "./form/NetworkingChannelForm.vue";

interface Props {
  channel: TelegramChannel | null;
  isEditing: boolean;
  initialType?: ChannelType; // New prop to know which type to create
  apiError?: string | null;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelFormModal',
  props: {
    channel: {},
    isEditing: { type: Boolean },
    initialType: {},
    apiError: {},
    loading: { type: Boolean }
  },
  emits: ["save", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const formData = reactive<TelegramChannel>({
  id: props.channel?.id || "",
  name: props.channel?.name || "",
  active: props.channel?.active ?? true,
  priority: props.channel?.priority || 0,
  type: props.channel?.type || (props.initialType as ChannelType),
  minRank: "",
  minAdminRank: "",
  availableForPackage: [],
  kickUsers: false,
  kickAfter: 3,
  kickAfterUnit: "day",
  monitoringEnabled: false,
  alertsType: undefined,
  monitoringConfig: { ...DEFAULT_MONITORING_CONFIG },
  lastFullCleanup: null,
});

const validationErrors = ref<string[]>([]);

if (props.channel) {
  Object.assign(formData, JSON.parse(JSON.stringify(props.channel)));
  // Ensure config exists if editing
  if (!formData.monitoringConfig) {
    formData.monitoringConfig = { ...DEFAULT_MONITORING_CONFIG };
  }
  // Normalize unit if it comes as plural (legacy data)
  if (formData.kickAfterUnit) {
    const unitMapping: Record<string, KickAfterUnit> = {
      days: "day",
      weeks: "week",
      months: "month",
      years: "year",
    };
    // Cast to string to check if it matches legacy plural forms
    const currentUnit = formData.kickAfterUnit as string;
    if (currentUnit in unitMapping) {
      formData.kickAfterUnit = unitMapping[currentUnit];
    }
  }
}

const updateFormData = (newData: TelegramChannel) => {
  Object.assign(formData, newData);
};

const handleValidation = (errors: string[]) => {
  validationErrors.value = errors;
};

const hasAttemptedSubmit = ref(false);

const handleSubmit = () => {
  hasAttemptedSubmit.value = true;
  if (validationErrors.value.length > 0) return;
  emit("save", { ...formData });
};

const formatType = (type?: ChannelType) => {
  return type === "networkMarketing" ? "Network Marketing" : "Servicio";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, _toDisplayString(__props.isEditing ? "Editar Canal de: " : "Nuevo Canal de: "), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["h5 mb-0 d-flex align-items-center gap-2 fw-medium", formData.type === 'networkMarketing' ? '' : 'text-info'])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas", 
                  formData.type === 'networkMarketing'
                    ? 'fa-users'
                    : 'fa-bullhorn'
                ])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(formatType(formData.type)), 1)
            ], 2),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close ms-auto",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (formData.type !== 'networkMarketing')
            ? (_openBlock(), _createBlock(ServiceChannelForm, {
                key: 0,
                "model-value": formData,
                "is-editing": __props.isEditing,
                "onUpdate:modelValue": updateFormData,
                onValidation: handleValidation
              }, null, 8, ["model-value", "is-editing"]))
            : (_openBlock(), _createBlock(NetworkingChannelForm, {
                key: 1,
                "model-value": formData,
                "is-editing": __props.isEditing,
                "onUpdate:modelValue": updateFormData,
                onValidation: handleValidation
              }, null, 8, ["model-value", "is-editing"])),
          (hasAttemptedSubmit.value && validationErrors.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex align-items-center mb-2" }, [
                  _createElementVNode("i", { class: "fas fa-exclamation-circle me-2" }),
                  _createElementVNode("h6", { class: "mb-0 fw-bold" }, "Atención")
                ], -1)),
                _createElementVNode("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (error, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.apiError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
                  _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }),
                  _createElementVNode("h6", { class: "mb-0 fw-bold" }, "Error")
                ], -1)),
                _createElementVNode("p", _hoisted_11, _toDisplayString(__props.apiError), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-danger fw-medium px-4 py-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
            disabled: __props.loading
          }, " Cancelar ", 8, _hoisted_13),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-success fw-medium px-4 py-2 shadow-sm",
            onClick: handleSubmit,
            disabled: validationErrors.value.length > 0 || __props.loading,
            style: {"min-width":"140px"}
          }, [
            (__props.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_15))
              : (_openBlock(), _createElementBlock("i", _hoisted_16)),
            _createTextVNode(" " + _toDisplayString(__props.isEditing ? "Guardar" : "Crear Canal"), 1)
          ], 8, _hoisted_14)
        ])
      ])
    ])
  ]))
}
}

})